import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    contactSupport_title: 'Обращение в службу технической поддержки',
    contactSupport_telephones: 'Телефоны службы технической поддержки:',
    contactSupport_eZhetysu: 'Для обращения в Службу Поддержки пройдите по ссылке:',
    contactSupport_description:
      'Инструкция по оформлению запроса в техническую поддержку',
    contactSupport_timeWork: 'Рабочее время с 09:00 до 18:30',
    contactSupport_timeLunch: 'Обеденное время с 13:00 до 14:30',
    contactSupport_step1: '1. Укажите адрес электронной почты для обратной связи',
    contactSupport_step2: '2. В заголовке кратко укажите тему запроса',
    contactSupport_step3: '3. В описании подробно распишите проблему',
    contactSupport_problemDescription:
      'Описание проблемы: Четко опишите, что происходит. Укажите номер заявки (если есть), ваши действия, которые приводят к ошибке, и текст ошибки.',
    contactSupport_additionalMaterials:
      'Дополнительные материалы: Обязательно приложите скриншоты или видео, где видна ошибка.',
    contactSupport_step4:
      '4. После обработки вашего запроса ответ будет направлен на указанный вами адрес электронной почты.',
    contactSupport_example:
      'Пример: "Номер заявки: 375593 При нажатии на кнопку «Отказ от контингента» возникает ошибка: «Заявление было обработано положительно». Снимок экрана во вложении".'
  },
  kk: {
    contactSupport_title: 'Техникалық қолдау қызметіне жүгіну',
    contactSupport_telephones: 'Техникалық қолдау телефондары:',
    contactSupport_eZhetysu:
      'Қолдау қызметіне хабарласу үшін мына сілтеме бойынша өтіңіз:',
    contactSupport_description: 'Техникалық қолдауға сұрау жіберу жөніндегі нұсқаулық',
    contactSupport_timeWork: 'Жұмыс уақыты 09:00-ден 18:30-ға дейін',
    contactSupport_timeLunch: 'Түскі үзіліс 13:00-ден 14:30-ға дейін',
    contactSupport_step1: '1. Кері байланыс үшін электрондық пошта мекенжайын көрсетіңіз',
    contactSupport_step2: '2. Тақырыпта қысқаша сұрау тақырыбын көрсетіңіз',
    contactSupport_step3: '3. Сипаттамада мәселені егжей-тегжейлі жазыңыз',
    contactSupport_problemDescription:
      'Мәселенің сипаттамасы: Нақты не болып жатқанын жазыңыз. Өтініш нөмірін (бар болса), қатеге әкелген әрекеттеріңізді және қате мәтінін көрсетіңіз.',
    contactSupport_additionalMaterials:
      'Қосымша материалдар: Міндетті түрде қатенің көрініп тұрған скриншотын немесе бейнесін тіркеңіз.',
    contactSupport_step4:
      '4. Сұрауыңыз өңделгеннен кейін жауап көрсетілген электрондық поштаға жіберіледі.',
    contactSupport_example:
      'Мысал: "Өтініш нөмірі: 375593 «Контингенттен бас тарту» батырмасын басқанда қате шығады: «Өтініш оң өңделді». Экран суреті қоса берілген".'
  }
});
